import { MediaContentShowcaseItem } from "@onnit-js/ui/components/module/MediaContentShowcase";

const ingredients: MediaContentShowcaseItem[] = [
    {
        image: `Citicoline.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: 'Cognizin<span class="oui-sup">®</span> Citicoline',
        summary:
            "A type of citicoline naturally produced by the brain.",
        detail:
            'Helps maintain levels of other chemicals that transport messages in the brain.<span class="oui-sup">†</span>'
    },
    {
        image: `LionsMane.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Lion’s Mane",
        summary:
            "A mushroom native to North America.",
        detail:
            'Helps support cognitive function.†<span class="oui-sup">†</span>'
    },
    {
        image: `L-Theanine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "L-Theanine",
        summary:
            'An amino acid that supports the production of dopamine and serotonin in the brain–two hormones that help induce relaxation via alpha wave activity.<span class="oui-sup">†</span>',
        detail:
            'Supports a positive mood state and alpha brain wave activity, promoting "flow state" - the feeling of being in the zone.<span class="oui-sup">†</span>'
    },
    {
        image: `Caffeine.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Caffeine",
        summary:
            "Contains 50mg (about half a cup of coffee) of the well-known stimulant found in many of your favorite products.",
        detail:
            'Even in lower doses, caffeine has been shown to promote alertness and focus.<span class="oui-sup">†</span>'
    },
    {
        image: `Huperzia-Serrata.png?q=40`,
        imageWidth: 560,
        imageHeight: 560,
        title: "Huperzia Serrata Extract",
        summary:
            'This Toothed Clubmoss contains Huperzine A.<span class="oui-sup">†</span>',
        detail:
            'Helps slow the breakdown of acetylcholine.<span class="oui-sup">†</span>'
    }
];

export default ingredients;
